import { defineMessages } from 'react-intl';

const messages = defineMessages({
  collections: {
    id: 'App.IntegrationsSetup.CollectionsSetup.Collections',
    defaultMessage: 'Collections',
  },
  collectionsAgency: {
    id: 'App.IntegrationsSetup.CollectionsSetup.CollectionsAgency',
    defaultMessage: 'Collections Agency',
  },
  daysAfterFAS: {
    id: 'App.IntegrationsSetup.CollectionsSetup.DaysAfterFAS',
    defaultMessage: 'Days to Keep Accounts In-House',
  },
  daysAfterFASError: {
    id: 'App.IntegrationsSetup.CollectionsSetup.daysAfterFASError',
    defaultMessage: 'Must be a number between 1 and 999',
  },
  minAmount: {
    id: 'App.IntegrationsSetup.CollectionsSetup.MinAmount',
    defaultMessage: 'Minimum Account Balance',
  },
  minAmountError: {
    id: 'App.IntegrationsSetup.CollectionsSetup.MinAmountError',
    defaultMessage: 'Amount must be between $100 and $999',
  },
  collectionsTooltip: {
    id: 'App.IntegrationsSetup.CollectionsSetup.CollectionsTooltip',
    defaultMessage:
      'Turn Collections integration On/Off and select a Collections agency to manage your ' +
      'property collections settings efficiently. Configure Days to Keep Accounts In-House, ' +
      'Collections Agency, and Minimum Account Balance for turnover.',
  },
  collectionsType: {
    id: 'App.IntegrationsSetup.CollectionsSetup.CollectionsType',
    defaultMessage: 'Collections Type',
  },
  automatic: {
    id: 'App.IntegrationsSetup.CollectionsSetup.Automatic',
    defaultMessage: 'Automatic',
  },
  manual: {
    id: 'App.IntegrationsSetup.CollectionsSetup.Manual',
    defaultMessage: 'Manual',
  },
  modalTitle: {
    id: 'App.IntegrationsSetup.CollectionsSetup.ModalTitle',
    defaultMessage: 'Collections',
  },
  modalUnderstandAndCertify: {
    id: 'App.IntegrationsSetup.CollectionsSetup.ModalUnderstandAndCertify',
    defaultMessage:
      'By enabling the Automated Collections Tracker, I understand and certify:',
  },
  modalContractSigned: {
    id: 'App.IntegrationsSetup.CollectionsSetup.ModalContractSigned',
    defaultMessage:
      'A contract with the selected collections agency has been signed, and they have ' +
      'confirmed they are prepared to receive claims from {propertyName}, ' +
      'facilitating seamless account transfers to the collections agency.',
  },
  modalVerifiedStatus: {
    id: 'App.IntegrationsSetup.CollectionsSetup.ModalVerifiedStatus',
    defaultMessage:
      'I have verified the collections status of all prior resident accounts and am ' +
      'prepared for any account not under Payment Plan, Sent to Collections, or Account ' +
      'Closed statuses to have a claim created by Fortress.',
  },
  modalAuthorizeSharing: {
    id: 'App.IntegrationsSetup.CollectionsSetup.ModalAuthorizeSharing',
    defaultMessage:
      'I authorize Fortress to share collections/claims with the selected collections ' +
      'agency for all Prior Resident households, contingent upon adherence to the ' +
      'predetermined criteria established by your property.',
  },
  modalCancel: {
    id: 'App.IntegrationsSetup.CollectionsSetup.ModalCancel',
    defaultMessage: 'Cancel',
  },
  modalSaveChanges: {
    id: 'App.IntegrationsSetup.CollectionsSetup.ModalSaveChanges',
    defaultMessage: 'Save Changes',
  },
  collectionsAgencyTooltip: {
    id: 'App.IntegrationsSetup.CollectionsSetup.CollectionsAgencyTooltip',
    defaultMessage:
      "Your organization isn't set up to use this agency. Please contact your admin for " +
      'further assistance.',
  },
  propertyCollectionSettingMissing: {
    id: 'App.IntegrationsSetup.CollectionsSetup.PropertyCollectionSettingMissing',
    defaultMessage:
      'This collection agency is not configured for your property. Please contact your ' +
      'admin to set up the collection settings.',
  },
  disableConfirmTitle: {
    id: 'App.IntegrationsSetup.CollectionsSetup.DisableConfirmTitle',
    defaultMessage: 'Turn off Automated Collections?',
  },
  disableConfirmBody: {
    id: 'App.IntegrationsSetup.CollectionsSetup.DisableConfirmBody',
    defaultMessage:
      'Past-due accounts for this property will no longer be sent to the collections ' +
      'agency. Are you sure you want to turn off Automated Collections?',
  },
  disableConfirmAction: {
    id: 'App.IntegrationsSetup.CollectionsSetup.DisableConfirmAction',
    defaultMessage: 'Turn Off',
  },
});

export default messages;
